/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {profileDirectorySearch} from '../api'

export const useMutationProfileDirectorySearch = createReactQueryMutationHook('profileDirectorySearch', profileDirectorySearch)
